var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"component"}},[_c('a',{staticClass:"twitter-timeline",attrs:{"data-lang":"sv","data-width":"340","data-height":"500","href":'https://twitter.com/' + _vm.id}},[_vm._v("Tweets by "+_vm._s(_vm.id))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0879b641","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeedTwitter.vue
// module id = null
// module chunks = 